import React, { Component } from 'react'

import * as Constants from '../../../helpers/Constants'
import * as Styles from './styles'

class Icon extends Component {
  render() {
    const { style } = this.props

    switch (Constants.WHITE_LABEL.id) {
      case Constants.HOMEPAL:
        return (
          <img
            src={require('../../../assets/images/gerylogo.png')}
            className={'logoLogin homepal'}
            alt="Logo"
          />
        )
      case Constants.SALANA:
        return (
          <img
            src={require('../../../assets/images/salana_icon.png')}
            className={'logoLogin salana'}
            alt="Logo"
          />
        )
      case Constants.CONZIGNUS:
        return (
          <img
            src={require('../../../assets/images/conzignus.png')}
            className={'logoLogin conzignus'}
            alt="Logo"
          />
        )
      case Constants.SBC:
        return (
          <img
            src={require('../../../assets/images/sbc_logo.png')}
            className={'logoLogin sbc'}
            alt="Logo"
          />
        )
      case Constants.DELAGOTT:
        return (
          <img
            src={require('../../../assets/images/dela_gott_logo.png')}
            className={'logoLogin delagott'}
            alt="Logo"
          />
        )
      case Constants.BREDABLICK:
        return (
          <img
            src={require('../../../assets/images/bredablick_forvaltning_icon.png')}
            className={'logoLogin bredablick'}
            alt="Logo"
          />
        )
      case Constants.CASTOR:
        return (
          <img
            src={require('../../../assets/images/castor.png')}
            className={'logoLogin castor'}
            alt="Logo"
          />
        )
      default:
        return (
          <img
            src={require('../../../assets/images/gerylogo.png')}
            className={'logoLogin homepal'}
            alt="Logo"
          />
        )
    }
  }
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/common/icon/index.js